// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pfFx","name":"styles_name__21T3y","phone":"styles_phone__2lrkZ"};